import {DateInput, ListProps, NumberInput, SelectInput, TextInput,} from "ra-ui-materialui";
import {useOptions} from "../../shared/hooks/useOptions";
import {getDefaultListProps, initField} from "../../shared/utils";
import {CustomList} from "../../components/CustomList";
import {JournalEntryDatagrid} from "./JournalEntryDatagrid";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {
    AutocompleteInput,
    DatagridProps,
    NullableBooleanInput,
    NumberField,
    ReferenceInput,
    useListContext
} from "react-admin";
import {useEffect, useState} from "react";
import {Grid} from "@material-ui/core";
import {StatCard} from "../../components/StatCard";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";



const StaticStats = (props: DatagridProps) => {
    const {data} = useListContext(props);
    const [stats, setStats] = useState({amount_in: {id: 0, amount_in: "0"}, amount_out: {id: 0, amount_out: "0"}});
    useEffect(()=> {
        let amount_in=0
        let amount_out=0
        for(const d in data){
            if(data[d].journal_type === "I")
                amount_in += data[d].amount
            else if(data[d].journal_type === "O")
                amount_out += data[d].amount
        }
        setStats({
            amount_in: {
                id: 0,
                amount_in: `+ ${amount_in.toFixed(2)} €`,
            },
            amount_out: {
                id: 0,
                amount_out: `- ${amount_out.toFixed(2)} €`,
            }
        })
    }, [data])

    return (
        <>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats.amount_in}
                            source="amount_in"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                            style={{color: "green"}}
                        />
                    }
                    icon={<AttachMoneyIcon />}
                    subtitle="Totale importo"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats.amount_out}
                            source="amount_out"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                            style={{color: "red"}}
                        />
                    }
                    icon={<AttachMoneyIcon />}
                    subtitle="Totale imponibile"
                />
            </Grid>
        </>
    );
}


const DynamicStats = (props: DatagridProps) => {
    const {data, selectedIds} = useListContext(props);
    const [stats, setStats] = useState({amount_in: {id: 0, amount_in: "0"}, amount_out: {id: 0, amount_out: "0"}});

    useEffect(()=> {
        let amount_in=0
        let amount_out=0
        for(const d of selectedIds){
            if(data[d].journal_type === "I")
                amount_in += data[d].amount
            else if(data[d].journal_type === "O")
                amount_out += data[d].amount
        }
        setStats({
            amount_in: {
                id: 0,
                amount_in: `+ ${amount_in.toFixed(2)} €`,
            },
            amount_out: {
                id: 0,
                amount_out: `- ${amount_out.toFixed(2)} €`,
            }
        })
    }, [data, selectedIds])

    return (
        <>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats.amount_in}
                            source="amount_in"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                            style={{color: "green"}}
                        />
                    }
                    icon={<AttachMoneyIcon />}
                    subtitle="Totale importo"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats.amount_out}
                            source="amount_out"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                            style={{color: "red"}}
                        />
                    }
                    icon={<AttachMoneyIcon />}
                    subtitle="Totale imponibile"
                />
            </Grid>
        </>
    );
}


const JournalEntryHeader = (props: DatagridProps) => {

    return (
        <Grid container>
            <StaticStats {...props}/>
            <DynamicStats {...props}/>
        </Grid>
    );
}



export const JournalEntryList = (props: ListProps) => {
    const {data: options} = useOptions("journal_entry", "GET");
    const { data: optionsTerms } = useOptions("payment-terms", "GET");

    const filters = (options && optionsTerms) && [
        <TextInput {...initField("description", options)} label="Descrizione"/>,
        <TextInput {...initField("document_number", options)} label="Numero documento"/>,
        <TextInput {...initField("notes", options)} label="Note"/>,
        <NumberInput {...initField("amount", options)} label="Importo"/>,
        <DateInput
            {...initField("date", options)}
            label="Data"
        />,
        <DateInput source="date_after" label="Data dal"/>,
        <DateInput source="date_before" label="Data al"/>,
        <ReferenceInputSubject
            {...initField("subject", options)}
            alwaysOn
        />,
        <NullableBooleanInput {...initField("reconciled", options)}/>,
        <SelectInput
            choices={optionsTerms.method.choices}
            {...initField("payment_method", optionsTerms, "array")}
            label="Metodo di pagamento"
        />,
        <ReferenceInput reference="autocomplete/bank" {...initField("bank", options)}>
            <AutocompleteInput optionText="label"/>
        </ReferenceInput>
    ];

    return options ? <CustomList
            filterDefaultValues={{}}
            filters={filters}
            {...getDefaultListProps(props)}
            topElement={<JournalEntryHeader/>}
        >
            <JournalEntryDatagrid options={options}/>
        </CustomList>
        : null;
};
